var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.766 3.983c.243.1.464.248.65.434l6.168 6.167a2.003 2.003 0 010 2.833l-6.168 6.167a2.003 2.003 0 01-2.832 0l-6.168-6.167a2.001 2.001 0 010-2.833l6.168-6.167a2.001 2.001 0 012.182-.434zm-1.473 9.724A1 1 0 0013 13V8a1 1 0 00-2 0v5a1 1 0 00.293.707zm0 3a1 1 0 101.414-1.414 1 1 0 00-1.414 1.414z"
  })));
}

export default SvgError;